import { styled } from '@vr/ds-react'

export const BoxHidden = styled('div', {
  variants: {
    show: {
      true: {
        maxHeight: '300px',
        transition: 'all 0.5s ease',
        willChange: 'transform'
      },
      false: {
        overflow: 'hidden',
        maxHeight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        transition: 'all 0.5s ease',
        willChange: 'transform'
      }
    }
  },
  backgroundColor: '$neutralLight',
  padding: '$sm24 $sm16',
  margin: '$sm12',
  borderRadius: '$borderRadiusSmall'
})
